<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title>Users Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              v-model="userSelected"
              :search="search"
              item-key="key"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
              show-select
              class="elevation-1"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>
                    <v-checkbox v-model="row.selected" primary hide-details :rowData="row"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ row.item.id }}</td>
                  <td class="text-xs-left">{{ row.item.email }}</td>
                  <td class="text-xs-left">{{ row.item.firstName }}</td>
                  <td class="text-xs-left">{{ row.item.lastName }}</td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="doSelectUsers"><span class="btn-normal-primary">Select</span></v-btn>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Email', value: 'email' },
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' }
      ],
      loading: true,
      userSelected: []
    }
  },
  methods: {
    async doInit() {
      this.fetchData()
    },
    async fetchData() {
      const apiUrl = this.menu.getUserList
      if (apiUrl) {
        this.loading = true
        this.$http
          .get(expandURI(apiUrl))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((datamap) => {
                const userList = {
                  key: datamap.uid,
                  id: datamap.uid,
                  email: datamap.email,
                  firstName: datamap.firstName,
                  lastName: datamap.lastName
                }
                this.items.push(userList)
              })
              this.loading = false
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.loading = false
              this.message(data)
              this.fieldMessage(data)
            }
          })
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doSelectUsers() {
      this.$emit('select', this.userSelected)
      this.$emit('close')
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.procNotifParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    busClass: {
      type: String,
      default: ''
    },
    riskTxtRef: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
</style>
